/*SYSTEM IMPORTS*/
    import React from 'react'
    import c from 'classnames'
    
    import Link from 'components/Link'
    // import { Link } from 'react-router-dom'

export const MenuItem = props => {

    if( props.is_submenu && props.submenu && props.submenu.length )
    {
        return (
            <li>
                <span data-toggle="dropdown">
                    { props.title }
                </span>
                <ul className="dropdown-menu">
                    { props.submenu
                        .map(( item, index ) => (
                            <MenuItem key={ index } { ...item } onClick={ props.onClick } />
                        ))
                    }
                </ul>
            </li>
        )
    } else {
        return (
            <li>
                <Link to={ props.link } onClick={ props.onClick }>
                    <span>{ props.title }</span>
                </Link>
            </li>
        )
    }
}

const Menu = props => (
    <ul className={c( "nav", props.className )}>
        { props.children || null }
        { props.list
            .map(( item, index ) => (
                <MenuItem key={ index } { ...item } onClick={ props.onItemClick } />
            ))
        }
        { props.after_content || null }
    </ul>
)

export default Menu